import TextInput from "components/common/custom/forms/BootTextField/TextField";
import MultiSelect from "components/common/MultiSelect";
import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { handleEmpolyeeFilter } from "../config/empolyeeSlice";
import { GetAllDropDownData } from "features/eliglibility/eliglibility-check/config/eligibilityCheckApi";

const EmpolyeeListFilter = ({ watch, setValue, control }) => {
  const dispatch = useDispatch();
  const { empolyeeFilters, systemPrivillageList } = useSelector(
    (state) => state.empolyee
  );
  const { userData } = useSelector((state) => state.auth);
  const { allPermissionType } = useSelector((state) => state.role);
  const branchSetting = allPermissionType?.[0]?.rolemngmt_name?.find(
    (item) => item?.rolemngmttyp_name === "Branch"
  );

  const allBranches = JSON.parse(localStorage.getItem("branch_settings")) || [];

  const allowedBranchIds = userData?.employee?.branch_id
    ? userData?.employee?.branch_id
      ?.toString()
      ?.split(",")
      ?.map((id) => Number(id.trim()))
    : [];

  const filteredBranches = allBranches.filter((branch) =>
    allowedBranchIds.length > 0
      ? allowedBranchIds.includes(Number(branch.branch_id))
      : true
  );

  const handleBranch = (selected) => {
    if (!selected) {
      setValue("branch", null);
      dispatch(
        handleEmpolyeeFilter({
          check: "branch_id",
          value: null,
        })
      );
      return;
    }

    const value = {
      branch_name: selected.label,
      branch_id: selected.value,
    };
    setValue("branch", value);
    dispatch(handleEmpolyeeFilter({ check: "branch_id", value }));
  };

  const handleName = (selected) => {
    setValue("name", selected);
    dispatch(handleEmpolyeeFilter({ check: "emp_name", value: selected }));
  };
  const handleID = (seletced) => {
    setValue("id", seletced);
    dispatch(handleEmpolyeeFilter({ check: "emp_natid", value: seletced }));
  };
  const handleEmail = (seletced) => {
    setValue("email", seletced);
    dispatch(handleEmpolyeeFilter({ check: "emp_email", value: seletced }));
  };
  const handleRole = (seletced) => {
    if (!seletced) {
      setValue("role", null);
      dispatch(
        handleEmpolyeeFilter({
          check: "syspri_id",
          value: null,
        })
      );
      return;
    }

    const value = {
      syspri_name: seletced.label,
      syspri_id: seletced.value,
    };
    setValue("role", value);
    dispatch(handleEmpolyeeFilter({ check: "syspri_id", value }));
  };

  useEffect(() => {
    setValue("branch", empolyeeFilters?.branch_id);
    setValue("name", empolyeeFilters?.emp_name);
    setValue("email", empolyeeFilters?.emp_email);
    setValue("id", empolyeeFilters?.emp_name);
    setValue("role", empolyeeFilters?.syspri_id);
  }, []);

  useEffect(() => {
    if (systemPrivillageList?.length === 0) {
      dispatch(GetAllDropDownData());
    }
  }, [systemPrivillageList]);

  return (
    <Row>
      {userData?.employee?.syspri_id === 1 && Number(branchSetting?.list) === 1 && (
        <Col xs={12} sm={6} md={3} xl={2}>
          <label className="form-label">Branch</label>
          <Controller
            name="branch"
            control={control}
            rules={{ required: false }}
            render={({ field }) => (
              <MultiSelect
                {...field}
                menuPlacement="auto"
                closeMenuOnSelect={false}
                isMulti={false}
                options={filteredBranches?.map((item) => ({
                  value: item.branch_id,
                  label: item.branch_name,
                }))}
                isClearable={true}
                value={
                  field.value
                    ? {
                      value: field.value.branch_id,
                      label: field.value.branch_name,
                    }
                    : null
                }
                onChange={(selected) => handleBranch(selected)}
                formatOptionLabel={({ label }) => <div>{label}</div>}
                getOptionValue={(option) => option.value}
                placeholder="Choose ..."
              />
            )}
          />
        </Col>
      )}
      <Col xs={12} sm={6} md={3} xl={2}>
        <label className="form-label mb-2">System Privilage</label>
        <Controller
          name="role"
          control={control}
          size="sm"
          rules={{ required: false }}
          render={({ field }) => (
            <MultiSelect
              {...field}
              menuPlacement="auto"
              closeMenuOnSelect={false}
              isMulti={false}
              options={systemPrivillageList?.map((item) => ({
                value: item.syspri_id,
                label: item.syspri_name,
              }))}
              isClearable={true}
              value={
                field.value
                  ? {
                    value: field.value.syspri_id,
                    label: field.value.syspri_name,
                  }
                  : null
              }
              onChange={(selected) => handleRole(selected)}
              placeholder="Choose ..."
            />
          )}
        />
      </Col>
      <Col xs={12} sm={6} md={3} xl={2}>
        <TextInput
          name="name"
          label="Name"
          placeholder="Name"
          control={control}
          onChange={(selected) => handleName(selected)}
          required={false}
          size="sm"
        />
      </Col>
      <Col xs={12} sm={6} md={3} xl={2}>
        <TextInput
          name="id"
          label="ID"
          placeholder="ID"
          control={control}
          onChange={(selected) => handleID(selected)}
          required={false}
          size="sm"
        />
      </Col>
      <Col xs={12} sm={6} md={3} xl={2}>
        <TextInput
          name="email"
          label="Email"
          placeholder="Email"
          control={control}
          onChange={(selected) => handleEmail(selected)}
          required={false}
          size="sm"
        />
      </Col>
    </Row>
  );
};

export default EmpolyeeListFilter;
